import type {ViewState} from 'model-hub/scientific-models/structure-prediction/structurePredictionViewState';
import AaSequence from 'molbio/aa-sequences/AaSequence';
import {PolymerTabState, PolymerTabStateAttributes} from 'molbio/tabstates/PolymerTabState';
import {TabStateDefaults} from 'Navigation';

export interface AlphaFoldTabStateAttributes extends PolymerTabStateAttributes<AaSequence> {
  initialView?: ViewState;
}

interface AlphaFoldTabState {
  get<K extends keyof AlphaFoldTabStateAttributes>(key: K): AlphaFoldTabStateAttributes[K];
  set<K extends keyof AlphaFoldTabStateAttributes>(
    attributeName: K,
    value: AlphaFoldTabStateAttributes[K],
    options?: Backbone.ModelSetOptions
  ): AlphaFoldTabState;
  set(obj: Partial<AlphaFoldTabStateAttributes>): AlphaFoldTabState;
}

class AlphaFoldTabState extends PolymerTabState<AaSequence> {
  override defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: '3D Structure',
      closeable: false,
      // Persisted: FileState.saveLayoutPreference writes this value into
      // `workspaceBuffers.${fileType}` via POST /1/api/users/me/preferences, and
      // loadLayout matches on it to restore a tab. It also feeds the URL `tab`
      // param through activateTabByIdentifier, so shared links carry it too.
      // BuffersView additionally derives the tab's data-test-key from it with
      // phraseToCamelCase, so the Cypress selector 'proteinStructure' is
      // downstream of this value and cannot be renamed independently.
      preferenceKey: 'protein-structure',
    };
  }
}

export default AlphaFoldTabState;
